import * as tslib_1 from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Body2 } from 'sinoui-components/Text';
import dayjs from 'dayjs';
import MonthSelectPanelLayout from './MonthSelectPanelLayout';
import MonthItem from './MonthItem';
var Month = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 280px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding-bottom: 2px;\n  padding-left: 14px;\n"], ["\n  width: 280px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding-bottom: 2px;\n  padding-left: 14px;\n"])));
// tslint:disable-next-line:no-any
export default function MonthSelectPanel(props) {
    var year = props.yearChecked;
    var now = new Date();
    var nowMonth = now.getMonth() + 1;
    var nowYear = now.getFullYear();
    var checked;
    var sameMonth;
    if (nowMonth === props.monthLastChecked &&
        nowYear === props.yearLastChecked) {
        sameMonth = true;
        checked = true;
    }
    var monthArr = [
        { title: '一月', monthNum: 1 },
        { title: '二月', monthNum: 2 },
        { title: '三月', monthNum: 3 },
        { title: '四月', monthNum: 4 },
        { title: '五月', monthNum: 5 },
        { title: '六月', monthNum: 6 },
        { title: '七月', monthNum: 7 },
        { title: '八月', monthNum: 8 },
        { title: '九月', monthNum: 9 },
        { title: '十月', monthNum: 10 },
        { title: '十一月', monthNum: 11 },
        { title: '十二月', monthNum: 12 },
    ];
    var allDayLastChecked = props.allDayLastChecked;
    var monthChecked_All;
    var yearChecked_All;
    if (allDayLastChecked !== '') {
        monthChecked_All = dayjs(allDayLastChecked).month() + 1;
        yearChecked_All = dayjs(allDayLastChecked).year();
    }
    else {
        monthChecked_All = '';
        yearChecked_All = '';
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Month, null,
            React.createElement(Body2, null, year)),
        React.createElement(MonthSelectPanelLayout, null, monthArr.map(function (monthItem) {
            if (nowMonth === monthItem.monthNum) {
                if (nowYear === props.yearLastChecked &&
                    props.yearLastChecked === props.yearChecked &&
                    nowMonth === props.monthChecked) {
                    if (props.isLastChecked) {
                        return (React.createElement(MonthItem, { title: monthItem.title, selectMonth: props.selectMonth, monthNum: monthItem.monthNum, checked: true, sameMonth: true }));
                    }
                    else if (nowMonth !== props.monthChecked &&
                        nowYear === props.yearChecked) {
                        return (React.createElement(MonthItem, { title: monthItem.title, selectMonth: props.selectMonth, monthNum: monthItem.monthNum, sameMonth: true }));
                    }
                    else {
                        return (React.createElement(MonthItem, { title: monthItem.title, selectMonth: props.selectMonth, monthNum: monthItem.monthNum, sameMonth: true, enable: true }));
                    }
                }
                else if (props.yearLastChecked === yearChecked_All &&
                    props.yearLastChecked === props.yearChecked &&
                    monthItem.monthNum === props.monthChecked &&
                    monthItem.monthNum === monthChecked_All) {
                    return (React.createElement(MonthItem, { title: monthItem.title, selectMonth: props.selectMonth, monthNum: monthItem.monthNum, checked: true }));
                }
                else if (nowYear === props.yearChecked) {
                    return (React.createElement(MonthItem, { title: monthItem.title, selectMonth: props.selectMonth, monthNum: monthItem.monthNum, sameMonth: true }));
                }
            }
            else if (nowMonth !== monthItem.monthNum) {
                if ((nowYear === props.yearLastChecked ||
                    props.yearLastChecked === yearChecked_All) &&
                    props.yearLastChecked === props.yearChecked &&
                    monthItem.monthNum === props.monthLastChecked) {
                    return (React.createElement(MonthItem, { title: monthItem.title, selectMonth: props.selectMonth, monthNum: monthItem.monthNum, checked: true }));
                }
            }
            return (React.createElement(MonthItem, { title: monthItem.title, selectMonth: props.selectMonth, monthNum: monthItem.monthNum }));
        }))));
}
var templateObject_1;
//# sourceMappingURL=MonthSelectPanel.js.map